import { Pipe, PipeTransform } from '@angular/core';
import { MODE_OF_EXCUTION } from '@app/_shared/shared.enums';

@Pipe({
  name: 'modeOfExecution'
})
export class ModeOfExecutionPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if(typeof(value) === 'number') {
      return MODE_OF_EXCUTION[value]
    }
    return value
  }

}
